// SettingsModalPaneContents.jsx

import React from 'react';

// CSS
import './SettingsModalPaneContents.css';

/**
 * SettingsModalPaneContents
 *
 * Scrollable body area for a settings modal pane.
 *
 * @param {ReactNode} children - Pane body content.
 * @param {string} [className] - Optional extra class names.
 * @param {object} [style] - Optional inline style overrides.
 *
 * @returns {ReactNode} The rendered pane contents container.
 */
const SettingsModalPaneContents = React.memo(({
    children,
    className = '',
    style,
}) => (
    <div
      className={['settings-modal-pane-contents', className].filter(Boolean).join(' ')}
      style={style}
    >
        {children}
    </div>
));

SettingsModalPaneContents.displayName = 'SettingsModalPaneContents';

export default SettingsModalPaneContents;
